// extracted by mini-css-extract-plugin
export default {"categoriesWrapper":"PICategories_categoriesWrapper__BLcW4","categoriesLinkBlock":"PICategories_categoriesLinkBlock__fC9Rr"};